module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-ts"
  }, [_vm._v("BASIC CONSTRUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "ch-t",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_vm._v("TECHNIQUES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are three main construction methods for making the quilts in this book. With all the construction methods, the placement of color is crucial, and the composition needs to be built on a design wall so you can see it develop and make sure the placement of all the elements is correct.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-1"
    }
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/num1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "orgb"
  }, [_vm._v("METHOD ONE:")]), _vm._v(" Using a Grid of Blocks with ¼-KISSes and No Fusing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With this method, the ¼-KISSes (cornerstones) are machine basted to the blocks and then the blocks are sewn together. The key to this method is making A and B blocks. When you put the KISSes on the squares prior to sewing, you need to overlap them slightly where they meet in the middle of the squares. The best way to do this is clockwise overlapping in block A and counterclockwise overlapping in block B. This way, the lines created by the cornerstones will actually line up when the A and B blocks are alternated.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A and B blocks overlapping clockwise and counterclockwise")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another way to use this method is to use larger ¼-KISSes to create elliptical shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Small ¼-KISSes create circles; large ¼-KISSes create elliptical shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("A and B Blocks Step by Step")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Add the ¼-KISSes corner pieces to the blocks, overlapping the KISSes clockwise or counterclockwise "), _c('i', [_vm._v("before")]), _vm._v(" sewing the blocks together to create the quilt top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Machine baste using a stitch length of 3.5 to 4, about ⅛˝ from the edge, to hold the cornerstones in place.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Arrange and stitch the blocks into rows and stitch the rows together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Embellish as desired.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Example Quilts")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_c('i', [_vm._v("Color Play 2")]), _vm._v(" uses both the small and large ¼-KISSes. The smaller KISSes are used in the inner quilt, and the larger KISSes are used in the border, creating the elliptical shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Color Play 2")]), _vm._v(" by Louisa L. Smith (project instructions)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("This quilt starts with colorful blocks and large KISSes, using the basic Method One: Using a Grid of Blocks with ¼-KISSes and No Fusing. The trick is to make sure the white pieces always overlap the black ones to create the illusion of triple layers—simple and easy. The addition of four-color circles topped with white and black circles adds another layer to the quilt. The four-color circles create the illusion of a cutout, as they are the same fabric as the ovals adjacent to them. Even though they are fused, they appear to be cut out.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Triple Play")]), _vm._v(" by Louisa L. Smith, 42˝ × 36˝ (see "), _c('i', [_vm._v("Color Play 2")]), _vm._v(", above left and project instructions)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("While this quilt may look complicated, the blocks are put together using the basic Method One: Using a Grid of Blocks with ¼-KISSes and No Fusing. First-layer squares are black-and-white prints, and the KISSes are bright, colorful fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Quadrate")]), _vm._v(" by Louisa L. Smith (project instructions)")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-2"
    }
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/2a.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "orgb"
  }, [_vm._v("METHOD TWO A:")]), _vm._v(" Using a Grid and Fusing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This method is very straightforward and easy but allows for a lot of variations. Because the KISSes are fused to the First Layer of squares or rectangles after they are sewn together, a whole KISS can be fused at once—for example, the KISSes can be fused on every block junction, or junctions can be skipped, leaving whole blocks.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/tip.jpg"
    }
  }), _vm._v("  Make Strata Squares")]), _vm._v(" "), _c('p', {
    staticClass: "tipp"
  }, [_vm._v("An easy and interesting way to make the first layer of squares is to sew together various fabric strips and then crosscut them into strips to create the size of square needed (see Double Vision, Construct the First Layer).")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Step by Step")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Piece together squares or rectangles to form the First Layer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Draw the KISSes on the paper side of the paper-backed fusible web and cut them out ⅛˝ outside the drawn lines.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Draw KISSes on paper side of fusible web.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Fuse the cut-out KISSes to the selected fabrics and cut them out exactly on the lines.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("After fusing to fabrics, cut shapes out precisely on pencil lines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Audition the placement of the KISSes, and when you like the arrangement, fuse them to the First Layer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" Appliqué the edges of the KISSes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("6.")])]), _vm._v(" Embellish as desired.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Example Quilts")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('i', [_vm._v("Double Vision")]), _vm._v(" by Louisa L. Smith (project instructions)")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("The First Layer is created using the strata method (see Double Vision, Construct the First Layer) to create the grid of blocks. When you look at the quilt, notice that not all the junctions are covered, creating variations. In some cases, circles and flowers were added to the middle of the squares to add further interest and keep the eye moving around the composition.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13c.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Detail of "), _c('i', [_vm._v("Bird of Paradise")]), _vm._v(" (full quilt)")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("This quilt starts with 4½˝ × 4½˝ squares, but in addition to KISSes, ribbons sewn on the seamlines of some of the blocks create a strong grid. While the cornerstones make the squares disappear, the ribbons emphasize the grids, making the squares in that area of the quilt more important. There are a few extra KISSes in the middle of the circles as well, for added interest.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-3"
    }
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/2b.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "orgb"
  }, [_vm._v("METHOD TWO B:")]), _vm._v(" Using an Invisible Grid with Multiple Layers of HUGs and KISSes and Fusing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There are many possible First Layers using this method: whole cloth (a wonderful large print, a colorful piece of hand-dyed or hand-painted fabric); free-form, flowing curves; Four-Patches or Nine-Patches; or anything else you choose. Because there is no visible grid, you can use any size of KISSes and additional HUGs, or mix the sizes for the Second Layer.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Step by Step")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Use a First Layer made from whole cloth, a four-patch, a nine-patch, curved panels of different fabrics, or other design of your choice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Draw the KISSes and/or HUGs on the paper side of the paper-backed fusible web and cut them out ⅛˝ outside the drawn lines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Fuse the cut-out KISSes and/or HUGs to the selected fabrics and cut them out exactly on the lines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Audition the placement of the KISSes and/or HUGs and, when you like the arrangement, fuse them to the First Layer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" Appliqué the edges of the KISSes and/or HUGs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("6.")])]), _vm._v(" Embellish as desired.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Example Quilts with Curved First Layers")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("The First Layer is created with six curved panels. Large circles (HUGs) are fused to the First Layer before the KISSes are applied. You see the curves pop in and out between the KISSes, and the added HUGs create variety and add an element of surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Pattern on Pattern Two")]), _vm._v(" by Louisa L. Smith (full quilt also on)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("The First Layer is constructed using eight curved panels. The KISSes are appliquéd on top with black thread to emphasize the Second Layer and make it look as though it were tossed on top of the quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Scintillation")]), _vm._v(" by Louisa L. Smith (full quilt also on)")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Example Quilts with Wholecloth First Layers")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("The First Layer of this quilt is a piece of hand-dyed fabric with two small panels of commercial fabrics added in. Circles (HUGs) in a variety of sizes were fused to this layer before the Second Layer cornerstones (KISSes) and HUGs were added.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Synchronicity")]), _vm._v(" by Louisa L. Smith (full quilt also on)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("The First Layer of this quilt is also a piece of hand-dyed fabric with a small strip of commercial fabric added on the right for interest. The Second Layer is made using dupioni silk HUGs and KISSes.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Jekyll and Hyde")]), _vm._v(" by Louisa L. Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-4"
    }
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "",
      "src": "images/num3.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "orgb"
  }, [_vm._v("METHOD THREE:")]), _vm._v(" Pieced HUGs and KISSes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With this method, the gentle curves of the HUGs and KISSes are placed right sides together and stitched. When stitching, make sure the ¼-HUGs shapes are always on the bottom and the ¼-KISSes are always on the top.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Piecing the curves. Press seam allowance toward HUG.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Step by Step")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Cut the HUGs and KISSes and arrange them on the design wall with additional fabric as needed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" When you are happy with the placement, sew the HUGs and KISSes together to form blocks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Sew all the pieces together to form the quilt top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Embellish as desired.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" All piecing is done with ¼˝ seam allowances.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Example Quilts")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("All the KISSes and HUGs are pieced into the soft gray background fabric for this quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Kissing and a Hugging")]), _vm._v(" by Louisa L. Smith (project instructions)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcapl"
  }, [_vm._v("Here again the whole quilt top is pieced, and the same black-and-white fabric is used for the whole background.")]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Hugs and Kisses")]), _vm._v(" by Louisa L. Smith (project instructions)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6044f85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 78
// module chunks = 0